import React from 'react';
import { SvgWithColorProps } from '../interfaces';

const SVGCardScissors = ({ color }: SvgWithColorProps) => (
  <svg
    width='33'
    height='49'
    viewBox='0 0 33 49'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M22.3113 48.0305L10.9653 48.0015L1.03254 38.2219L0.945312 25.9959L2.75973 24.1539L6.75495 24.1249L6.60375 3.49069L8.55774 1.50921L12.8844 1.23029L14.664 2.97934L14.536 12.387L19.2582 1.14894L21.439 0.759613L25.6901 2.78758L26.1611 4.92596L21.2645 17.9422L30.4762 19.0695L32.3313 20.8941L32.4593 37.3038L22.3171 48.0247L22.3113 48.0305ZM11.9191 45.683L21.311 45.7062L30.1214 36.3915L30.011 21.8761L29.4061 21.2834L18.0486 19.8946L23.7419 4.75745L23.6605 4.39718L21.1075 3.17691L20.9098 3.21177L14.6698 18.0874L12.1342 18.1049L12.3262 3.94394L12.0005 3.61853L9.59871 3.77542L8.94156 4.44367L9.1451 31.8068L6.81892 31.8242L6.77821 26.455L3.74255 26.4782L3.28313 26.9431L3.35873 37.2399L11.9249 45.6772L11.9191 45.683Z'
      fill={color}
    />
  </svg>
);

export default SVGCardScissors;
